{
  "version": 1,
  "asset_id": "93666988-fbd3-46a5-878b-4204ab84059d",
  "project_id": "765508a6-9c9d-45ab-81ce-ecfbc5eb2942",
  "url": "/__l5e/assets-v1/93666988-fbd3-46a5-878b-4204ab84059d/Impact.png",
  "r2_key": "a/v1/765508a6-9c9d-45ab-81ce-ecfbc5eb2942/93666988-fbd3-46a5-878b-4204ab84059d/Impact.png",
  "original_filename": "Impact.png",
  "size": 589637,
  "content_type": "image/png",
  "created_at": "2026-08-18T18:34:42Z"
}
